import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { QA_NAME_BACK_BTN } from '../../../constants/qa'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { ICON_CHEVRON_DIRECTION, IconChevron } from '../../Icon'

import * as styles from './EntityProfileHeaderTitleBackButton.module.css'

function EntityProfileHeaderTitleBackButton({
  className = styles.EntityProfileHeaderTitleBackButton,
  height = BUTTON_HEIGHT_32,
  isLoading,
  qaName = QA_NAME_BACK_BTN,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <Button.Flat
      isGrey
      beforeIconProps={{
        Icon: IconChevron,
        iconProps: { direction: ICON_CHEVRON_DIRECTION.LEFT },
      }}
      className={className}
      height={height}
      isSkeleton={isLoading}
      qaName={qaName}
      tooltip={t('Profile.BackBtnKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={onClick}
    />
  )
}

export default EntityProfileHeaderTitleBackButton
